import { render, staticRenderFns } from "./UrlCheck.vue?vue&type=template&id=4b18cd48&lang=pug&"
import script from "./UrlCheck.vue?vue&type=script&lang=ts&"
export * from "./UrlCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports